import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

export const adminGuard: CanActivateFn = (_route, _state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  if (auth.role === 'Admin')   return true;
  // Partner user trying to access admin → redirect to partner
  return router.createUrlTree(['/partner/dashboard']);
};

export const partnerGuard: CanActivateFn = (_route, state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  if (auth.role === 'Admin') return true;
  if (auth.role !== 'Partner') return router.createUrlTree(['/admin/dashboard']);

  // Partner: only Active partners reach the portal; others see the onboarding/status screen.
  const onboarding = state.url.startsWith('/partner/onboarding');
  if (auth.partnerStatus === 'Active') {
    return onboarding ? router.createUrlTree(['/partner/dashboard']) : true;
  }
  return onboarding ? true : router.createUrlTree(['/partner/onboarding']);
};

export const clientGuard: CanActivateFn = (_route, state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  // Allow token-based access via ?token= query param (handled inside the module)
  if (state.url.includes('token=')) return true;
  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  if (auth.role === 'Client' || auth.role === 'Admin') return true;
  return router.createUrlTree(['/login']);
};
